import { Injectable } from '@angular/core';
import { SuppliersService } from '../_services/settings/suppliers.service';
import { SupplierModel } from '../_models/supplier.model';

@Injectable()
export class Suppliers {
  suppliers: SupplierModel[];
  loaded: boolean = false;
  loadRequested: boolean = false;
  callBacks: Function[] = [];

  constructor(private suppliersService: SuppliersService) { }

  getAll(callBack: Function = null) {
    if (!this.loaded)
      this.reload(callBack);
    else if (callBack)
      callBack(this.suppliers);
    return this.suppliers;
  }

  reload(callBack: Function = null) {
    if (callBack)
      this.callBacks.push(callBack);
    if (!this.loadRequested) {
      this.loadRequested = true;
      this.suppliersService.getAllSuppliers().subscribe((result) => {
        this.suppliers = result;
        this.loaded = true;
        for (let calback of this.callBacks) {
          calback(result);
          this.callBacks = this.callBacks.filter(cb => cb != calback);
        }
        this.loadRequested = false;
      });
    }
  }
}